import styled, { css } from 'styled-components';

import * as styles from '../../styles';

const ControllerWrapper = styled.div`
  display: ${({ theme }) => (theme.controllerInline ? 'inline-flex' : 'flex')};
  position: relative;
  width: ${props => styles.inputWidths[props.theme.controllerWidth] || styles.inputWidths.large};

  ${({ theme }) =>
    theme.controllerInline &&
    css`
      &:not(:first-child) {
        margin-left: ${styles.inlineGutter}px;
      }
    `}
`;

export default ControllerWrapper;
